// Badge cosmético só — não é usado em nenhum gate de acesso, só pra exibir
// um resumo amigável do conjunto de permissões da pessoa. `level` (0/1/2)
// existe só pra reaproveitar o styled-component LevelBadge, que já colore
// por esse número.
// Administrador = quem pode mudar a permissão de outros usuários
// (`manage_gym_users`) -- é a capacidade mais sensível do sistema, não
// só editar dados cadastrais da academia (`manage_gym_profile`, que
// não implica isso). Decisão do Pedro, 2026-08-25. O dono real de uma
// academia recebe as duas permissões juntas no cadastro
// (GYM_OWNER_PERMISSION_CODES), então isso não muda nada pra ele --
// só passa a diferenciar corretamente um funcionário que só edita o
// perfil da academia de quem de fato administra outros usuários.
const resolveAccessLevel = (permissions: string[] = []): number => {
  if (permissions.includes('manage_gym_users')) return 2;
  // `student` é a permissão padrão de todo aluno -- não conta como acesso
  // de colaborador. Só vira nível 1 se tiver alguma outra permissão além
  // dela (aí sim é funcionário/staff, mesmo que também seja aluno).
  const hasStaffPermission = permissions.some(code => code !== 'student');
  if (hasStaffPermission) return 1;
  return 0;
};

const labelLevelAccess = (permissions: string[] = []): string => {
  const level = resolveAccessLevel(permissions);

  if (level === 2) return 'Administrador(a)';
  if (level === 1) return 'Colaborador(a)';
  return 'Aluno(a)';
};

export { labelLevelAccess, resolveAccessLevel };
